import { Helmet } from 'react-helmet-async';
import { useClientConfig } from 'src/hooks/useClientConfig';

const NEWTRAL_DEFAULT_GTM_ID = 'GTM-5RSPMQ7';

const buildGtmSnippet = (gtmId: string) => `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;

const buildGa4Snippet = (ga4Id: string) => `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${ga4Id}');
  `;

const buildLdJson = (client: ReturnType<typeof useClientConfig>) => {
	const name = client?.metaTitle ?? client?.name ?? 'Chatbot | Asistente conversacional de Newtral';
	const description =
		client?.metaDescription ??
		'Chatbot | Asistente conversacional de Newtral, dónde encontrarás información sobre fact-checks, fakes, articulos, sueldos de politicos, leyes y muchos más.';
	const url = client?.canonicalUrl ?? 'https://chatbot.trueflag.ai/';
	const publisherName = client?.name ?? 'Newtral';
	const publisherUrl = client?.publisherUrl ?? client?.canonicalUrl ?? 'https://trueflag.ai/';
	const publisherLogo = client?.image ?? 'https://trueflag.ai/static/logo.47b9836b964e51feb1db.svg';
	return JSON.stringify({
		'@context': 'http://schema.org',
		'@type': 'WebPage',
		name,
		description,
		url,
		publisher: { '@type': 'Organization', name: publisherName, url: publisherUrl, logo: publisherLogo }
	});
};

const Analytics = () => {
	const client = useClientConfig();
	const gtmId = client ? client.gtmId : NEWTRAL_DEFAULT_GTM_ID;
	const ga4Id = client?.ga4Id;
	const ldJson = buildLdJson(client);

	return (
		<Helmet>
			{__PROD__ && gtmId && (
				<script id="google-tag-manager" async>
					{buildGtmSnippet(gtmId)}
				</script>
			)}
			{__PROD__ && ga4Id && <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4Id}`} />}
			{__PROD__ && ga4Id && (
				<script id="ga4-init" async>
					{buildGa4Snippet(ga4Id)}
				</script>
			)}
			<script type="application/ld+json">{ldJson}</script>
		</Helmet>
	);
};

export default Analytics;
